import React from "react"
import { Button, Typography, Box } from "@mui/material"

const AnaliseAllModalContent = ({ onConfirm, analiseBtn }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={1}
    >
      {analiseBtn ? (
        <Typography>
          Tem certeza que deseja analisar todos os registros filtrados?
        </Typography>
      ) : (
        <Typography>
          Tem certeza que deseja não analisar todos os registros filtrados?
        </Typography>
      )}
      <Box display="flex" gap={2} mt={2} justifyContent="center">
        <Button variant="contained" color="success" onClick={onConfirm}>
          Sim
        </Button>
      </Box>
    </Box>
  )
}

export default AnaliseAllModalContent
